module.exports = __webpack_public_path__ + "img/edit-customer.43102aa6.svg";